import {
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo, useEffect, useRef, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile, deviceDetect } from "react-device-detect";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  addWarterMarker,
  setHash,
  serviceLogs,
  getAllStorageOTP,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import DialogWait from "../../components/CustomDialog/DialogWait";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isEmpty } from "lodash";
import qs from "qs";

import {
  CRSBirthAddressKey,
  CRSData,
  CRSRadioChecked,
} from "../../utils/GlobalKey";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  textPrimary: {
    fontFamily: "DB Heavent",
    color: "var(--primary)",
  },
});
var fix_phone = ["0838479208", "0631878568", "0981644889"];
const Otp = (props) => {
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const classes = useStyle();
  const [lang, setLang] = useState(getData("lang"));
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [minute, setMinute] = useState(0);
  const [secondDown, setSecondDown] = useState(0);
  const [minuteDown, setMinuteDown] = useState(0);
  const [isCountDown, setIsCountDown] = useState(false);
  const [second, setSecond] = useState(0);
  const [otpValue, setOtpValue] = useState("");
  const [errorValidate, setErrorVaildate] = useState("");
  const checkuserinfo = getData("checkuserinfo");
  const idc = getData("idc") ? getData("idc") : "";
  const crsBirthAddressInfo = getData(CRSBirthAddressKey) ?? "";
  const crsDeclareLocationInfo = getData(CRSData) ?? "";
  const CRSRadioCheckedInfo = getData(CRSRadioChecked) ?? false;
  const [dataSendSMS, setDataSendSMS] = useState({
    reference: "",
    token_otp: "",
  });
  const [againOTP, setAgainOTP] = useState(false);
  const [HeaderManp, setHeaderManp] = useState("");
  const [isCheck, setIsCheck] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [goCameback, setGoCameback] = useState(false);
  let stampUpload = getData("stampUpload")
    ? getData("stampUpload")
    : {
        uploadImage: false,
        eSignature: false,
        uploadImageBookBank: false,
        uploadImageHouse: false,
      };
  const [jumpPage, setJumpPage] = useState(false);
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  let snapIdCard = getData("uploadImage");
  const [switchToUpload, setSwitchToUpload] = useState(false);
  let intervalLock = useRef(null);
  let intervalOtp = useRef(null);
  const unExpDate = getData("unExpDate");
  const checkJumpPage = async () => {
    await getImage();
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(crsBirthAddressInfo) ||
      isEmpty(crsDeclareLocationInfo)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                  storeData("uploadImage", snapIdCard);
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const getHeadToken = async () => {
    let save_complete = false;
    try {
      const {
        valuePrefixTH,
        valuePrefixEN,
        prefixEN,
        nationality,
        nameTH,
        middlenameTH,
        lastnameTH,
        nameEN,
        middlenameEN,
        lastnameEN,
        idCard,
        backIdCard,
        birthday,
        expireDateCard,
        otherPrefixTH,
      } = idc;
      const { f0_email, f0_mobile_phone, aeCode } = checkuserinfo;
      const CRSDeclareLocationRequest = crsDeclareLocationInfo.map((item) => {
        /*
        checkNotax: false = ไม่มีหมายเลขประจำตัวผู้เสียภาษี
        country: (string) = ชื่อประเทศ
        countryId: (string) = CountryId
        notaxId: (int) = choice ที่เลือก เมื่อ ไม่มีหมายเลขประจำตัวผู้เสียภาษี
        notaxId2Text: (string) = เหตุผลอธิบายเพิ่มเติม เมื่อเลือก choice 2
        taxNumber: (string) = หมายเลขประจำตัวผู้เสียภาษี
        */
        return {
          SAffcc_CNT_TaxResidence: item.countryId,
          SAffcc_TIN: item.taxNumber,
          SAffcc_Mrnt_Id: item.notaxId,
          SAffcc_Explain: item.notaxId2Text,
        };
      });
      var postData = {
        f0_title: valuePrefixTH,
        f0_title_text: valuePrefixTH === "205" ? otherPrefixTH : "",
        f0_title_eng: valuePrefixEN,
        f0_title_text_eng: prefixEN,
        f0_national_country_id: nationality.value,
        f0_firstname: nameTH,
        f0_middlename: middlenameTH,
        f0_lastname: lastnameTH,
        f0_firstname_eng: nameEN,
        f0_middlename_eng: middlenameEN,
        f0_lastname_eng: lastnameEN,
        f0_national_id: idCard,
        f0_lazer_card: backIdCard,
        f0_date_birth: birthday,
        f0_expire_date: expireDateCard,
        f0_email: f0_email,
        f0_mobile: f0_mobile_phone,
        f0_investment_consultant_id: aeCode,
        f0_consent_fatca: true,
        f0_consent_openaccount: true,
        f0_city_of_birth: crsBirthAddressInfo.province
          ? crsBirthAddressInfo.provinceNameEn
          : crsBirthAddressInfo.city,
        f0_country_of_birth: crsBirthAddressInfo.country.value,
        f0_us_citizen: "false".toString(),
        f0_non_us_citizen: "true".toString(),
        f0_crs_tax_detail: JSON.stringify(CRSDeclareLocationRequest),
      };
      storeData("stamp_page", "ADDRESS");

      var last_stamp = JSON.stringify(await getAllStorageOTP("ADDRESS"));
      // console.log(last_stamp);
      storeData("openSizeUploadImage", true);
      const uploadImage = await addWarterMarker(
        getData("uploadImage"),
        false,
        "",
      );
      clearData("openSizeUploadImage");
      const uploadImageHouse = await addWarterMarker(
        getData("uploadImageHouse"),
        false,
        "",
      );
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/header/manp`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "กรุณาตรวจสอบข้อมูลบัตรประจำตัวประชาชนอีกครั้ง";
            let title = "ขออภัยข้อมูลของท่านไม่ถูกต้อง";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
            return false;
          } else {
            const HeaderManp = res.data.Data[0];
            await storeData("HeaderManp", HeaderManp);
            setHeaderManp(HeaderManp);
            setIsLoading(true);
            await saveImage();
            ///// start all
            const questionsAnswer = getData("questionsAnswer")
              ? getData("questionsAnswer")
              : "";

            const saveData = [
              {
                name: "PDPA",
                url: `${Configs.baseAPIURL03}/form/signed_tnc/manp`,
                postData: {
                  head_token: HeaderManp.head_token,
                  product_id: "",
                  comfrimation: 1,
                  code: "PDPA",
                },
              },
              {
                name: "TNC",
                url: `${Configs.baseAPIURL03}/form/signed_tnc/manp`,
                postData: {
                  head_token: HeaderManp.head_token,
                  product_id: "",
                  comfrimation: 1,
                  code: "TNC",
                },
              },
              {
                name: "CRS",
                url: `${Configs.baseAPIURL03}/form/signed_tnc/manp`,
                postData: {
                  head_token: HeaderManp.head_token,
                  product_id: "",
                  comfrimation: 1,
                  code: "CRS",
                },
              },
              {
                name: "questions",
                url: `${Configs.baseAPIURL03}/form/questions/manp`,
                postData: {
                  id_card: idCard,
                  aecode: aeCode ? aeCode : "null",
                  question_json: [...questionsAnswer],
                },
              },
              {
                name: "front card",
                url: `${Configs.baseAPIURL03}/form/document/upload/idcard/front`,
                postData: {
                  head_token: HeaderManp.head_token,
                  id: "0",
                  image_base64: uploadImage ? uploadImage : "",
                },
              },
              {
                name: "comeback",
                url: `${Configs.baseAPIURL03}/form/comeback/manp`,
                postData: {
                  head_token: HeaderManp.head_token,
                  last_stamp: last_stamp,
                  stamp_page: "ADDRESS",
                },
              },
            ];
            if (unExpDate) {
              await saveImageHouse();
              saveData.push({
                name: "uploadImageHouse",
                url: `${Configs.baseAPIURL03}/form/document/upload/household_registration`,
                postData: {
                  head_token: HeaderManp.head_token,
                  id: "0",
                  image_base64: uploadImageHouse || "",
                },
              });
            }
            for (let i = 0; i < saveData.length; i++) {
              if (saveData[i].name !== "questions") {
                setIsLoading(true);
                try {
                  await GlobalApi.post(
                    saveData[i].url,
                    qs.stringify(saveData[i].postData),
                    header,
                  )
                    .then(async (res) => {
                      setIsLoading(false);
                      if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                        let mss =
                          res.data.Data[0].MsgDesc !== ""
                            ? res.data.Data[0].MsgDesc
                            : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง (" +
                              i +
                              1 +
                              ")";
                        let title = "เกิดข้อผิดพลาด";
                        setIsLoading(false);
                        setIsModalError(true);
                        setModalErrorTitle(title);
                        setModalErrorDes(mss);
                        i = saveData.length;
                      } else {
                        if (saveData[i].name === "front card") {
                          await clearData("uploadImage");
                        }
                      }
                    })
                    .catch((er) => {
                      setIsLoading(false);
                      let title = "เกิดข้อผิดพลาด";
                      let mss =
                        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                        getData("api_error")?.message +
                        ")";
                      setIsModalError(true);
                      setModalErrorTitle(title);
                      setModalErrorDes(mss);
                      serviceLogs(
                        saveData[i].url,
                        saveData[i].postData,
                        er,
                        saveData[i].name,
                      );
                      i = saveData.length;
                    });
                } catch (error) {
                  setIsLoading(false);
                  setIsModelWait(true);
                  i = saveData.length;
                }
              } else {
                setIsLoading(true);
                try {
                  await GlobalApi.post(saveData[i].url, saveData[i].postData)
                    .then((res) => {
                      setIsLoading(false);
                      if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                        let mss =
                          res.data.Data[0].MsgDesc !== ""
                            ? res.data.Data[0].MsgDesc
                            : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง (" +
                              i +
                              1 +
                              ")";
                        let title = "เกิดข้อผิดพลาด";
                        setIsLoading(false);
                        setIsModalError(true);
                        setModalErrorTitle(title);
                        setModalErrorDes(mss);
                        i = saveData.length;
                      } else {
                        // console.log("save" + saveData[i].name + "  success");
                      }
                    })
                    .catch((er) => {
                      // console.log(er);
                      // console.log("save" + saveData[i].name + "  error");
                      // console.log(getData("api_error")?.message);
                      setIsLoading(false);
                      let title = "เกิดข้อผิดพลาด";
                      let mss =
                        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                        getData("api_error")?.message +
                        ")";
                      setIsModalError(true);
                      setModalErrorTitle(title);
                      setModalErrorDes(mss);
                      serviceLogs(
                        saveData[i].url,
                        saveData[i].postData,
                        er,
                        "getHeadToken",
                      );
                      i = saveData.length;
                    });
                } catch (error) {
                  // console.log(error);
                  // console.log("catch" + saveData[i].name + "  error");
                  // console.log(getData("api_error")?.message);
                  setIsLoading(false);
                  setIsModelWait(true);
                  serviceLogs(
                    saveData[i].url,
                    saveData[i].postData,
                    error,
                    saveData[i].name,
                  );
                  i = saveData.length;
                }
              }
              if (i === saveData.length - 1) {
                save_complete = true;
              }
            }

            ///// end all
          }
        })
        .catch((er) => {
          console.log(er);
          setIsLoading(false);
          // let mss = er : 'กรุณาตรวจสอบข้อมูลบัตรประจำตัวประชาชนอีกครั้ง';
          let title = "เกิดข้อผิดพลาด";
          let mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง (00)";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
          serviceLogs(`header/manp >> catch`, postData, er, "header/manp");
          return false;
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      // setIsModelWait(true);
      let title = "เกิดข้อผิดพลาด";
      let mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง (01)";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
      serviceLogs(`getHeadToken > catch`, "", error, "getHeadToken");
      return false;
    }
    // console.log("end gettoken");
    return save_complete;
  };
  const saveImage = async () => {
    const uploadImage = getData("uploadImage") ? getData("uploadImage") : "";
    const uploadImage_str = uploadImage.split("data:image/jpeg;base64,");
    const head_token = getData("HeaderManp")?.head_token;
    const hashData = setHash(uploadImage);
    const watermark_image = await addWarterMarker(uploadImage, false, "");
    try {
      var postData = {
        head_token,
        base64: uploadImage_str[1],
        type: "data:image/jpeg;base64,",
        key: "uploadImage",
        hash: hashData,
        watermark_image: watermark_image,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/upload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          // setIsLoading(false);
          stampUpload.uploadImage = true;
          await storeData("stampUpload", stampUpload);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
          serviceLogs(`${Configs.baseURL}/api/upload`, "", er, "saveImage");
        });
    } catch (error) {
      // console.log(error);
      serviceLogs(`${Configs.baseURL}/api/upload`, "", error, "saveImage");
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  const saveImageHouse = async () => {
    const uploadImageHouse = getData("uploadImageHouse")
      ? getData("uploadImageHouse")
      : "";
    const uploadImage_str = uploadImageHouse.split("data:image/jpeg;base64,");
    const head_token = getData("HeaderManp")?.head_token;
    const hashData = setHash(uploadImageHouse);
    const watermark_image = await addWarterMarker(uploadImageHouse, false, "");
    try {
      var postData = {
        head_token,
        base64: uploadImage_str[1],
        type: "data:image/jpeg;base64,",
        key: "uploadImageHouse",
        hash: hashData,
        watermark_image: watermark_image,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/upload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          // setIsLoading(false);
          stampUpload.uploadImageHouse = true;
          storeData("stampUpload", stampUpload);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          setIsModelWait(true);
          serviceLogs(
            `${Configs.baseURL}/api/upload`,
            "",
            er,
            "saveImageHouse",
          );
        });
    } catch (error) {
      // console.log(error);
      serviceLogs(`${Configs.baseURL}/api/upload`, "", error, "saveImageHouse");
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  const getUserdata = async (last_stamp) => {
    clearData("last_stamp");
    last_stamp = await JSON.parse(last_stamp);
    if (last_stamp !== null && last_stamp.length > 0) {
      var i = last_stamp.length;
      var old_data = {};
      while (i--) {
        if (
          last_stamp[i].key !== "checkuserinfo" ||
          last_stamp[i].key !== "HeaderManp"
        ) {
          storeData(last_stamp[i].key, last_stamp[i].value);
        }
        if (
          last_stamp[i].key === "checkuserinfo" ||
          last_stamp[i].key === "uploadImage" ||
          last_stamp[i].key === "idc"
        ) {
          old_data[last_stamp[i].key] = last_stamp[i].value;
        }
      }
      const stamp_page = getData("stamp_page") ? getData("stamp_page") : "";
      if (stamp_page === "") {
        storeData("stamp_page", "ADDRESS");
      }
      storeData("old_data", old_data);
    }
  };
  const handleNext = () => {
    sendOTP();
  };
  const handleChange = (e) => {
    setErrorVaildate("");
    if (e.target.value.length === 6) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
    setOtpValue(e.target.value.replace(/[^0-9]+/g, ""));
  };
  const get = (key, defaultValue = "") => getData(key) || defaultValue;
  const nextPage = async (e) => {
    await clearData("first_otp");
    const current_ic = get("current_ic");
    const dipchip_ic = get("dipchip_ic");
    const last_stamp = get("last_stamp");
    const passNDID = get("pass_ndid");
    const pass_ThaID = get("pass_ThaID");
    if (isEmpty(head_token)) {
      setIsLoading(true);
      const token = await getHeadToken();
      if (token) {
        props.history.push("/address");
      }
    } else {
      const comebackWithOtp = get("comebackWithOtp");
      const goToAddress = get("goToAddress");

      if (goToAddress) {
        await checkAndSaveData();
        return;
      }

      if (comebackWithOtp) {
        props.history.push("/address");
      } else if (last_stamp) {
        await getUserdata(last_stamp);
        storeData("comebackWithOtp", true);
      }
      const stamp_page = get("stamp_page", "ADDRESS");
      const routeMap = {
        ADDRESS: "/address",
        PROD: "/career",
        SUIT: "/suit",
        JOBS: "/status",
        ATS: "/example_sign",
        SUMMARY: "/summary",
        CONFIRM: "/products_consent",
        FINISH: "/tc_confirm",
      };
      if (["NDID", "EKYC", "DIPCHIP"].includes(stamp_page)) {
        saveComeback(stamp_page);
      } else if (stamp_page === "ThaID") {
        if (pass_ThaID) {
          saveComeback("CONFIRM");
        } else {
          saveComeback("ThaID");
        }
      } else if (routeMap[stamp_page]) {
        props.history.push(routeMap[stamp_page]);
      } else {
        props.history.push("/" + stamp_page.toLowerCase());
      }
    }
    const pageAgree = get("page_agree");
    if (!pageAgree || typeof pageAgree !== "object") {
      await storeData("page_agree", { termandcon: 1, pdpa: 1 });
    }
    await storeData("dipchip_ic", dipchip_ic);
    await storeData("current_ic", current_ic);
  };

  const sendSMS = async () => {
    clearInterval(intervalLock.current);
    setAgainOTP(false);
    setOtpValue("");
    setErrorVaildate("");
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const postData = {
      phone_number: checkuserinfo.f0_mobile_phone,
      session: new Date().getTime() + " : " + navigator.userAgent,
    };

    // Local not send OTP
    if (
      process.env.REACT_APP_ENVIRONMENT === "local" ||
      process.env.REACT_APP_ENVIRONMENT === "development"
    ) {
      setDataSendSMS({
        phone_number: checkuserinfo.f0_mobile_phone,
        reference: "DAOL8307",
        token_otp: "a5f58795bf26ec3bedeaa5fd89aa62d886ec0798",
      });
      setTimesOtp("03", "00");
      setAgainOTP(false);
      return;
    }

    try {
      GlobalApi.post(`${Configs.baseAPIURL01}/sms/send`, postData, header)
        .then((res) => {
          // console.log('resData: ', res);
          if (!isEmpty(res?.data?.reference)) {
            setDataSendSMS({
              phone_number: res.data.phone_number,
              reference: res.data.reference,
              token_otp: res.data.token_otp,
            });
            let min = res.data.otp_time.split(".");
            min[0] = min[1] === "00" ? min[0] - 1 : min[0];
            setTimesOtp(min[0], min[1]);
            setIsCountDown(false);
          } else {
            setAgainOTP(true);

            let min = res?.data?.time.split(".");
            min[0] = min[1] === "00" ? min[0] - 1 : min[0];

            setIsCountDown(true);
            setCountDown(min[0], min[1]);

            setModalErrorTitle(
              lang === "th" ? res?.data?.title_th : res?.data?.title_en,
            );
            setModalErrorDes(
              lang === "th" ? res?.data?.message_th : res?.data?.message_en,
            );
            setIsModalError(true);
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    } catch (error) {}
  };
  const sendOTP = async () => {
    if (
      process.env.REACT_APP_ENVIRONMENT === "local" ||
      process.env.REACT_APP_ENVIRONMENT === "development" ||
      !process.env.REACT_APP_ENVIRONMENT
    ) {
      nextPage();
      return;
    }

    if (!isEmpty(otpValue)) {
      if (fix_phone.includes(checkuserinfo.f0_mobile_phone)) {
        nextPage();
        return;
      }
      setIsLoading(true);
      try {
        var postData = {
          phone_number: dataSendSMS.phone_number,
          otp: otpValue,
          token: dataSendSMS.token_otp,
          reference: dataSendSMS.reference,
        };

        await GlobalApi.post(
          `${Configs.baseAPIURL01}/api/verifyotp`,
          qs.stringify(postData),
          header,
        )
          .then((res) => {
            setIsLoading(false);
            // console.log(res);
            if (res?.data?.api_status === 1) {
              //TODO next padge
              nextPage();
            } else {
              if (res?.data?.api_status === 2) {
                setAgainOTP(true);
                let min = res?.data?.time.split(".");
                min[0] = min[1] === "00" ? min[0] - 1 : min[0];

                setIsCountDown(true);
                setCountDown(min[0], min[1]);
                setMinute(0);
                setSecond(0);

                setModalErrorTitle(
                  lang === "th" ? res?.data?.title_th : res?.data?.title_en,
                );
                setModalErrorDes(
                  lang === "th" ? res?.data?.message_th : res?.data?.message_en,
                );
                setIsModalError(true);
              } else {
                setErrorVaildate(
                  lang === "th" ? res?.data?.message_th : res?.data?.message_en,
                );
              }
            }
          })
          .catch((er) => {
            serviceLogs(
              `${Configs.baseAPIURL01}/api/verifyotp`,
              postData,
              er,
              "verifyotp",
            );
            setIsLoading(false);
            setIsModelWait(true);
          });
      } catch (error) {
        // console.log(error);
        serviceLogs(
          `${Configs.baseAPIURL01}/api/verifyotp`,
          postData,
          error,
          "verifyotp",
        );
        setIsLoading(false);
        setIsModelWait(true);
      }
    } else {
      setErrorVaildate("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  const setCountDown = async (m, s) => {
    let times = s === "00" ? 60 : s;
    let seconds = s;
    let minutes = m;
    intervalLock.current = await setInterval(() => {
      setMinuteDown(minutes);
      times -= 1;
      seconds = parseInt(times % 60, 10);
      if (seconds <= 0) {
        times = 60;
        minutes -= 1;
      }
      setSecondDown(seconds < 10 ? "0" + seconds : seconds);
      if (minutes < 0) {
        setIsCountDown(false);
        setIsModalError(false);
        clearInterval(intervalLock.current);
      }
    }, 1000);
  };
  const setTimesOtp = (m, s) => {
    let times = s === "00" ? 60 : s;
    let seconds = s;
    let minutes = m;
    intervalLock.current = setInterval(() => {
      setMinute(minutes);
      times -= 1;
      seconds = parseInt(times % 60, 10);
      if (seconds <= 0) {
        times = 60;
        minutes -= 1;
      }
      setSecond(seconds < 10 ? "0" + seconds : seconds);
      if (minutes < 0) {
        setAgainOTP(true);
        clearInterval(intervalLock.current);
      }
    }, 1000);
  };
  const checkAndSaveData = async () => {
    const old_data = getData("old_data") ? getData("old_data") : "";
    const checkuserinfo = (await getData("checkuserinfo"))
      ? getData("checkuserinfo")
      : "";
    const base = getData("uploadImage");
    if (isEmpty(base)) {
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง<br/>ไม่สามารถอัพโหลดรูปได้";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
      setSwitchToUpload(true);
    }
    storeData("openSizeUploadImage", true);
    const uploadImage = await addWarterMarker(base, false, "");
    clearData("openSizeUploadImage");
    const idc = (await getData("idc")) ? getData("idc") : "";
    const checkuserinfo_change = await checkArr(
      old_data.checkuserinfo,
      checkuserinfo,
    );
    const uploadImage_change = getData("old_data")
      ? await (old_data.uploadImage === uploadImage ? false : true)
      : false;
    const idc_change = await checkArr(old_data.idc, idc);
    const stamp_page = getData("stamp_page")
      ? getData("stamp_page")
      : "ADDRESS";
    // console.log("old_data :", old_data);

    const saveData = [];
    if (idc_change) {
      saveData.push({
        name: "update idc",
        url: `${Configs.baseAPIURL03}/form/customer_info/manp`,
        postData: {
          head_token: head_token,
          f1_lazer_card: idc.backIdCard,
          f1_title: idc.valuePrefixTH === "205" ? idc.otherPrefixTH : "",
          f1_title_text: idc.otherPrefixTH,
          f1_firstname: idc.nameTH,
          f1_middlename: idc.middlenameTH,
          f1_firstname_eng: idc.nameEN,
          f1_middlename_eng: idc.middlenameEN,
          f1_lastname: idc.lastnameTH,
          f1_lastname_eng: idc.lastnameEN,
          f1_date_birth: idc.birthday,
          f1_expire_date: idc.expireDateCard,
          f1_national_country_id: idc.nationality.value,
        },
      });
    }
    if (uploadImage_change) {
      saveData.push({
        name: "update uploadImage",
        url: `${Configs.baseAPIURL03}/form/document/upload/idcard/front`,
        postData: {
          head_token: head_token,
          id: "0",
          image_base64: uploadImage ? uploadImage : "",
        },
      });
    }
    if (checkuserinfo_change) {
      saveData.push({
        name: "update checkuserinfo",
        url: `${Configs.baseAPIURL03}/form/header_info/manp`,
        postData: {
          head_token: head_token,
          f1_mobile: checkuserinfo.f0_mobile_phone,
          f1_email: checkuserinfo.f0_email,
          f1_investment_consultant_id: checkuserinfo.aeCode,
        },
      });
    }
    if (idc_change || uploadImage_change || checkuserinfo_change) {
      var last_stamp = JSON.stringify(await getAllStorage(stamp_page));
      saveData.push({
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: stamp_page,
        },
      });
    }
    // console.log("saveData : ", saveData);
    if (saveData.length > 0) {
      await storeData("goToAddress", true);
      setIsLoading(true);
      for (let i = 0; i < saveData.length; i++) {
        try {
          await GlobalApi.post(saveData[i].url, saveData[i].postData)
            .then(async (res) => {
              if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                let mss =
                  res.data.Data[0].MsgDesc !== ""
                    ? res.data.Data[0].MsgDesc
                    : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                let title = "เกิดข้อผิดพลาด";
                setIsLoading(false);
                setIsModalError(true);
                setModalErrorTitle(title);
                setModalErrorDes(mss);
                i = saveData.length;
              } else {
                if (i === saveData.length - 1) {
                  setIsLoading(false);
                  var old_data = {};
                  old_data.checkuserinfo = checkuserinfo;
                  old_data.uploadImage = uploadImage;
                  old_data.idc = idc;
                  await storeData("old_data", old_data);
                  await clearData("goToAddress");
                  await props.history.push("/address");
                }
                // console.log("save" + saveData[i].name + "  success");
              }
            })
            .catch((er) => {
              // console.log(er);
              // console.log("save" + saveData[i].name + "  error");
              // console.log(getData("api_error")?.message);
              setIsLoading(false);
              let title = "เกิดข้อผิดพลาด";
              let mss =
                "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                getData("api_error")?.message +
                ")";
              setIsModalError(true);
              setModalErrorTitle(title);
              setModalErrorDes(mss);
              serviceLogs(
                saveData[i].url,
                saveData[i].postData,
                er,
                "checkAndSaveData",
              );
              i = saveData.length;
            });
        } catch (error) {
          // console.log(error);
          // console.log("catch" + saveData[i].name + "  error");
          // console.log(getData("api_error")?.message);
          serviceLogs(
            saveData[i].url,
            saveData[i].postData,
            error,
            "checkAndSaveData",
          );
          setIsLoading(false);
          setIsModelWait(true);
          i = saveData.length;
        }
      }
    } else {
      await storeData("goToAddress", true);
      await clearData("goToAddress");
      await props.history.push("/address");
    }
  };
  const checkArr = (o1, o2) => {
    let i = 0;
    for (var k in o1) {
      if (k === "nationality") {
        if (o1[k].label !== o2[k].label || o1[k].value !== o2[k].value) {
          i++;
        }
      } else {
        if (o1[k] !== o2[k]) {
          i++;
        }
      }
    }
    if (i === 0) {
      return false;
    } else {
      return true;
    }
  };
  const saveComeback = async (type) => {
    storeData("stamp_page", type);
    const last_stamp = JSON.stringify(await getAllStorage(type));

    const saveData = {
      name: "comeback",
      url: `${Configs.baseAPIURL03}/form/comeback/manp`,
      postData: {
        head_token: head_token,
        last_stamp: last_stamp,
        stamp_page: type,
      },
    };

    setIsLoading(true);

    try {
      const res = await GlobalApi.post(
        saveData.url,
        qs.stringify(saveData.postData),
        header,
      );

      setIsLoading(false);

      const isSuccess = res?.data?.Data?.[0]?.[0]?.IsSuccess === 1;

      if (!isSuccess) {
        const mss =
          res?.data?.Data?.[0]?.MsgDesc ||
          "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";

        setIsModalError(true);
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes(mss);
        return;
      }

      // ✅ สำเร็จ
      clearData("currentStep");
      clearData("editPage");
      storeData("passedSummary", true);

      switch (type) {
        case "NDID":
          props.history.push("/ndid_information");
          break;
        case "EKYC":
          props.history.push("/ekyc");
          break;
        case "DIPCHIP":
          props.history.push("/dipchip_waiting");
          break;
        case "ThaID":
          props.history.push("/thaid_waiting");
          break;
        default:
          props.history.push("/products_consent");
          break;
      }
    } catch (error) {
      setIsLoading(false);

      const apiError = getData("api_error")?.message || "ไม่ทราบสาเหตุ";
      const mss = `ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(${apiError})`;

      setIsModalError(true);
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes(mss);
    }
  };

  useEffect(() => {
    const last_stamp = getData("last_stamp") ? getData("last_stamp") : "";
    if (last_stamp) {
      setGoCameback(true);
    } else {
      checkJumpPage().then((res) => {
        if (res) setJumpPage(true);
      });
    }

    const first_otp = getData("first_otp");
    const isFirstOTP =
      first_otp === undefined || first_otp === null || first_otp === ""
        ? true
        : first_otp;
    if (isFirstOTP) {
      sendSMS();
    } else {
      clearData("first_otp");
      const { history } = props;
      if (history.length > 3) {
        history.goBack();
      } else {
        history.push("/"); // Handle when user close tab and open again by URL.
      }
    }
    storeData("first_otp", false);
    clearData("back_form_otp");
  }, []);
  const clickBack = async () => {
    await storeData("back_form_otp", true);
    await clearData("first_otp");
    // await props.history.push("/idcForm");
    await props.history.push("/crs_consent");
  };

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.otp?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
            comeback={goCameback}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.otp}
                        clickBack={(e) => clickBack()}
                        ndid_list={goCameback}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: isMobile ? "100%" : "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.otp?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <>
                                <Grid>
                                  <Typography className="font-title">
                                    ระบบได้ส่งรหัส OTP ไปยัง
                                  </Typography>
                                  <Grid
                                    className="font-title"
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                  >
                                    <Typography
                                      item
                                      className={clsx(
                                        "font-24 pt-1",
                                        classes.textPhone,
                                      )}
                                    >
                                      {checkuserinfo?.f0_mobile_phone?.slice(
                                        0,
                                        6,
                                      )}
                                      xxxx
                                    </Typography>
                                    <Typography
                                      item
                                      className="font-title"
                                      sx={{ paddingTop: "2px" }}
                                    >
                                      เรียบร้อยแล้ว
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl
                                    variant="standard"
                                    fullWidth
                                    error
                                    autoComplete="off"
                                  >
                                    <TextField
                                      className="font-20"
                                      label="โปรดระบุรหัส  OTP*"
                                      variant="standard"
                                      value={otpValue}
                                      type="tel"
                                      inputProps={{ maxLength: 6 }}
                                      onChange={handleChange}
                                      error={
                                        isEmpty(otpValue) &&
                                        !isEmpty(errorValidate)
                                      }
                                    />
                                    <FormHelperText className="text-error">
                                      {!isEmpty(errorValidate) && errorValidate}
                                    </FormHelperText>
                                  </FormControl>
                                </Grid>
                                <Grid>
                                  <Grid container className="grid-start-end">
                                    <Grid item xs={10}>
                                      <Typography
                                        className={clsx(
                                          classes.textPrimary,
                                          "font-18",
                                          "pr-2",
                                        )}
                                        sx={{ display: "inline" }}
                                      >
                                        เลขอ้างอิง {dataSendSMS.reference}
                                      </Typography>
                                    </Grid>
                                    <Grid item>
                                      <Grid>
                                        <Typography
                                          className={clsx(
                                            classes.textPrimary,
                                            "font-18",
                                          )}
                                        >{`${minute} : ${second}`}</Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Typography
                                    variant="body2"
                                    className="requirement-label"
                                    sx={{
                                      color: "gray",
                                      fontWeight: "normal !important",
                                      mb: 0.25,
                                      fontSize: 18,
                                    }}
                                  >
                                    หมายเหตุ: เพื่อสัญญาณเครือข่ายที่เสถียร
                                    แนะนำให้เปิดใช้งาน 3G/4G/5G
                                  </Typography>
                                </Grid>
                              </>
                            }
                          />

                          <Grid sx={{ marginTop: againOTP && "-18%" }}>
                            {againOTP && (
                              <Grid>
                                <ButtonRight
                                  hide={!againOTP}
                                  BtnSecondary
                                  text={"ขอรหัส OTP ใหม่"}
                                  onNextPage={sendSMS}
                                />
                              </Grid>
                            )}
                            <Grid className={"pt-3"}>
                              <ButtonRight
                                isDisbled
                                disbled={isCheck}
                                text={translations?.[lang]?.otp?.next}
                                onNextPage={handleNext}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={"ขออภัย"}
            massage={
              "เบอร์โทรศัพท์ที่ท่านระบุซ้ำกับข้อมูลในระบบ</br>กรุณากรอกข้อมูลอีกครั้ง</br>หรือติดต่อ DAOL Contact Center </br>0 2351 1800</br>"
            }
            btn={lang === "th" ? "ตกลง" : "OK"}
          />
          <DialogCustoms
            open={isModel}
            isModel={setIsModel}
            title={"ท่านอยู่ระหว่างการเปิดบัญชี"}
            btnPrimary={"ดำเนินการต่อ"}
            btnSecondary={"กรอกข้อมูลใหม่"}
          />
          <DialogError
            imgModalError
            open={isModalError}
            isModel={(e) => {
              setIsModalError(e);
              clearInterval(intervalLock.current);
              if (switchToUpload) {
                props.history.push("/snapIdCard");
              }
            }}
            title={modalErrorTitle}
            massage={modalErrorDes}
            countDown={minuteDown + ":" + secondDown}
            isCountDown={isCountDown}
            btnPrimary={lang === "th" ? "ตกลง" : "OK"}
          />
        </>
      )}
    </>
  );
};
export default memo(Otp);
